export const replaceWithNullIfEmptyString = (fieldValue: string) => {
  if (typeof fieldValue === 'string' && !fieldValue.length) {
    return null;
  }

  return fieldValue;
};
